import {FilterItemDto} from "./misc";

export const creatorSortOptions: FilterItemDto[] =
  [
    {id: 1, name: 'Rating (high - low)', value: 'creator.average_rating', description: 'Sort by average rating (high - low)', direction: 'DESC', active: true},
    {id: 2, name: 'Rating (low - high)', value: 'creator.average_rating', description: 'Sort by average rating (low - high)', direction: 'ASC', active: true},
    {id: 3, name: 'Recently Updated', description: 'Sort by recently updated (most recent first)', value: 'applicationStatusModifiedDate', direction: 'DESC', active: true},
    {id: 6, name: 'Rank (high - low)', description: 'Sort by rank (high - low)', value: 'creator.rank', direction: 'DESC', active: true},
    {id: 7, name: 'Rank (low - high)', description: 'Sort by rank (low - high)', value: 'creator.rank', direction: 'ASC', active: true},
    {id: 8, name: 'Recently Joined', description: 'Sort by recently joined (most recent first)', value: 'creator.createdDate', direction: 'DESC', active: true},
    {id: 4, name: 'Product Sent', description: 'Sort by product sent (most recent first)', value: 'productSent', direction: 'DESC', active: true},
    {id: 5, name: 'Product Not Sent', description: 'Sort by product not sent (most recent first)', value: 'productSent', direction: 'ASC', active: true},
  ];


export const noProductSortOptions: FilterItemDto[] =
  [
    {id: 1, name: 'Recently Joined', value: 'creator.createdDate', direction: 'DESC', active: true},
    {id: 2, name: 'Rating (high - low)', value: 'creator.average_rating', direction: 'DESC', active: true},
    {id: 3, name: 'Rating (low - high)', value: 'creator.average_rating', direction: 'ASC', active: true},
    {id: 4, name: 'Would Recommend', value: 'recommend', direction: 'DESC', active: true},
    {id: 5, name: 'Recently Updated', value: 'applicationStatusModifiedDate', direction: 'DESC', active: true},
    {id: 6, name: 'Rank (high - low)', value: 'creator.rank', direction: 'DESC', active: true},
    {id: 7, name: 'Rank (low - high)', value: 'creator.rank', direction: 'ASC', active: true},
  ];
